.filter-wrapper{max-width:100%}.filter-wrapper .dropdown-toggle.active{color:#5930fb;border-color:#5930fb}.input{width:300px}
/*# sourceMappingURL=appscripts-cli-filter.component-WSGTPKSS.css.map */
